import { Typography } from 'antd';
import './ReleComponent.scss';
import { ReleData } from '../../../../models/telemetry';

const { Title } = Typography;

interface ReleComponentProps {
  reles: ReleData[];
}

const ReleComponent = ({ reles }: ReleComponentProps) => {
  return (
    <div className="ReleComponent">
      <Title level={5} className={'CardComponent__title'}>
        Reles
      </Title>
      {reles.length === 0 && (
        <Title level={2} className={'CardComponent__value'}>
          No hay datos
        </Title>
      )}
      <div className="ReleComponent__list">
        {reles.map((data, index) => (
          <div className="ReleComponent__item" key={index}>
            <div
              className={`ReleComponent__dot ${data.state ? 'ReleComponent__dot--on' : 'ReleComponent__dot--off'}`}
              title={data.name}
            />
            <span className="ReleComponent__label">{data.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReleComponent;
